// extracted by mini-css-extract-plugin
export default {"workspaceIcon":"WorkspaceTitle_workspaceIcon__x8Tg7","workspaceTitleWrapper":"WorkspaceTitle_workspaceTitleWrapper__jGqcE","workspaceName":"WorkspaceTitle_workspaceName__ZX1vR"};